import { render, staticRenderFns } from "./Experiments.vue?vue&type=template&id=4f827827&"
import script from "./Experiments.vue?vue&type=script&lang=js&"
export * from "./Experiments.vue?vue&type=script&lang=js&"
import style0 from "./Experiments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports